// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IBnH","colMin":"styles_colMin__28551"};